export type TimezoneDto = {
  id: string;
  name: string;
  offset: string;
};

export type TimezoneModel = TimezoneDto;

export const DEFAULT_TIMEZONE: string = 'Europe/London';
